import { createTheme, ThemeProvider } from "@mui/material/styles";
import React, { createRef, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import OrdersPageHeader from "./ordersPageHeader/ordersPageHeader";
import OrdersMaterialTable from "./ordersMaterialTable";
import { ordersData } from "./api";
import LoaderComponent from "../../LoaderComponent/LoaderComponent";
import { toast } from "react-toastify";
import { log } from "../../Helper";
import { useUserInfo } from "../../common/user-context";

const tableRef = createRef();

export const Orders = () => {
  const { userData } = useUserInfo();
  const [isInternal, setIsInternal] = useState(true);
  const [isExternalFactoryUser, setIsExternalFactoryUser] = useState(false);
  const [tableData, setTableData] = useState(Array(0));
  const [isLoading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(5000);
  const [pageNumber, setPageNumber] = useState(0);

  const supplierId = userData.supplierNumber;
  const supplierName = userData.descr;

  // dom functions
  const handleTableRefresh = () => {
    tableRef.current.state.query.orderBy = null;
    tableRef.current.state.query.orderDirection = "";
    getTableData();
  };

  const theme = createTheme({
    palette: {
      primary: {
        main: "#367C2B", // Green
      },
      secondary: {
        main: "#FFDE00", // Yellow
      },
      text: {
        primary: "#000000", // Black
      },
    },
    typography: {
      fontFamily: "Open Sans, sans-serif",
    },
    components: {
      // MaterialTable toolbar and selection text styling
      MuiToolbar: {
        styleOverrides: {
          root: {
            "& .MuiTypography-root": {
              color: "#000000", // Black color for selection text
            },
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          body2: {
            color: "#000000", // Black color for body text including selection count
          },
        },
      },
      MuiCheckbox: {
        styleOverrides: {
          root: {
            "&.Mui-checked": {
              color: "#FFDE00", // Checked color
            },
            "&.MuiCheckbox-indeterminate": {
              color: "#FFDE00", // Indeterminate color (for select all)
            },
          },
        },
      },
    },
  });

  // fetching the tableData

  const getTableData = async () => {
    setLoading(true);
    try {
      const response = await ordersData(
        isInternal,
        supplierId,
        pageSize,
        pageNumber
      );
      if (response != undefined) {
        setTableData(response);
      }
      log("data fetching is completed!");
    } catch (error) {
      toast.warn("Error occured when fetching data: ", error);
      setTableData(Array(0));
    }
    setLoading(false);
  };

  useEffect(() => {
    setIsInternal(userData.internal);
    setIsExternalFactoryUser(userData.externalFactoryUser);
    getTableData();
  }, []);

  const columns = [
    {
      title: "FACTORY",
      field: "factory",
      sorting: false,
    },
    {
      title: "COMAR",
      field: "comar",
      sorting: false,
    },
    {
      title: "PIN",
      field: "pin",
      sorting: false,
    },
    {
      title: "FORWARDER",
      field: "forwarder",
      sorting: false,
    },
    {
      title: "SHIP TO ACCOUNT NAME",
      field: "shipToAccountName",
      sorting: false,
    },
    {
      title: "SHIP TO CITY",
      field: "shipToCity",
      sorting: false,
    },
    {
      title: "FORWARDER INFORMED",
      field: "forwarderInformed",
      sorting: false,
    },
    {
      title: "AVIS DATE",
      field: "avisDate",
      sorting: false,
    },
    {
      title: "Q BLOCK",
      field: "qBlock",
      sorting: false,
    },
    {
      title: "PARKING LOT",
      field: "parkingLot",
      sorting: false,
    },
    {
      title: "SHIPPING ORDER",
      field: "shippingOrder",
      sorting: false,
    },
    {
      title: "DRIVER NAME",
      field: "driverName",
      sorting: false,
    },
    {
      title: "TRUCK PLATE",
      field: "truckPlate",
      sorting: false,
    },
    {
      title: "TRAILER PLATE",
      field: "trailerPlate",
      sorting: false,
    },
    {
      title: "FREE TEXT",
      field: "freeText",
      sorting: false,
      minWidth: '250px',
    },
    {
      title: "DOCS",
      field: "links",
      sorting: false,
    },
  ];

  return (
    <div className="allOrders rounded-sm p-[5px]">
      <OrdersPageHeader
        supplierName={supplierName}
        isInternal={isInternal}
        isExternalFactoryUser={isExternalFactoryUser}
        handleTableRefresh={handleTableRefresh}
      />
      <div id="orderTable">
        <ThemeProvider theme={theme}>
          {isLoading && <LoaderComponent />}
          {!isLoading && (
            <OrdersMaterialTable
              tableName={"LoadSchedule"}
              tableRef={tableRef}
              columns={columns}
              tableData={tableData}
              pageSize={pageSize}
              setPageNumber={setPageNumber}
              handleTableRefresh={handleTableRefresh}
            />
          )}
        </ThemeProvider>
      </div>
    </div>
  );
};
